/**
 * Wacht tot een conditie true teruggeeft, met retries.
 * @param {Function} conditionFn - moet true returnen als klaar
 * @param {Function} callback - wordt uitgevoerd als klaar
 * @param {Object} options
 * @param {number} options.intervalMs - wachttijd tussen checks
 * @param {number} options.timeoutMs - max totale wachttijd
 */
// export function retryUntilAvailableQuiz(
//   conditionFn,
//   callback,
//   { intervalMs = 300, timeoutMs = 10000 } = {}
// ) {
//   const start = Date.now();

//   const interval = setInterval(() => {
//     if (conditionFn()) {
//       clearInterval(interval);
//       callback();
//     } else if (Date.now() - start >= timeoutMs) {
//       clearInterval(interval);
//       console.warn("[retryUntilAvailable] Timeout reached.");
//     }
//   }, intervalMs);
// }

function ensureDataLayer() {
  if (typeof window === "undefined") return false;
  window.digitalData = window.digitalData || { events: [] };
  if (!Array.isArray(window.digitalData.events)) window.digitalData.events = [];
  return true;
}

// (optioneel) simpele dedupe per pagina
const sentKeys = new Set();

export function trackPageImpressionQuiz({
  boxname = "tools",
  pageid = "default",
  lang = "nl-BE",
}) {
  if (!ensureDataLayer()) return;

      const dnow = Date.now();
      const currentUrl = new URL(window.location.href);
      const param_lang = lang.substring(0, 2);
      const boxUrl = `/EDUbox/games/quiz/${boxname}/`;
      const trackUrl = `${boxUrl}${pageid}`;
      const eduboxTitle = `EDUbox Games - Quiz - ${boxname} - ${pageid}`;
      const baseUrl = `https://${currentUrl.hostname}`;
      const pageUrl = `${baseUrl}${trackUrl}`;

      const key = `${trackUrl}|${param_lang}`;
  if (sentKeys.has(key)) return; // voorkom dubbele pushes
  sentKeys.add(key);

      window.digitalData.events.push({
        event: {
          schema: "iglu:be.vrt/page_impression/jsonschema/1-1-0",
          data: {
            timestamp: dnow,
          },
        },
        context: [
          {
            schema: "iglu:be.vrt/context_page/jsonschema/1-2-1",
            data: {
              pagename: trackUrl,
              touchpointbrand: "vrt",
              contentbrand: "edubox",
              pageurl: pageUrl,
              pagetitle: eduboxTitle,
              domain: "www.vrt.be",
              pagepath: trackUrl,
              pagelanguage: param_lang,
              sitesection1: "",
              sitesection2: "",
              sitesection3: eduboxTitle,
              sitesection4: "",
              pageid: `vrtedubox${trackUrl}`,
          },
      },
    ],
  });
}
